import * as actionTypes from '../action-types';

export const initalState = {};

export default (state = initalState, action) => {
  switch (action.type) {
    case actionTypes.DEVICE_SERVICE_REQUEST_STARTED: {
      const { homeId, requestId, dsrEnabled } = action;
      return {
        ...state,
        [homeId]: { requestId, dsrEnabled },
      };
    }

    case actionTypes.COMMAND_STATUS_ACK:
    case actionTypes.COMMAND_STATUS_NACK:
    case actionTypes.PENDING_CHANGE_TIMED_OUT: {
      const changedKey = Object.keys(state).find(
        k =>
          state[k]?.requestId === (action.requestId || action.data?.requestId),
      );

      if (changedKey) {
        const newState = {
          ...state,
        };

        delete newState[changedKey];
        return newState;
      }

      return state;
    }

    default: {
      return state;
    }
  }
};
